<template>
  <div class="soundIntroduce" style="position:relative;width:100%;height:100%">
    <!-- AI语音解决方案 -->
    <div class="soundProduct">
      <div class="soundProductTitle">产品方案</div>
      <div class="soundTopToggle">
        <div class="ai_flex_items">
          <div class="soundTopToggle1">
            <div
              @click="toggleFn(1)"
              :class="mark?'aiChangeOneTitleOne':'aiChangeOneTitleTwo'"
            >一体机方案：</div>
            <div
              @click="toggleFn(1)"
              :class="mark?'aiChangeOne':'aiChangeTwo'"
            >整合4路音频接入和并发处理功能，输出结构化指令数据，适用小型站点。</div>
            <div v-if="!mark" class="aiArrow"></div>
          </div>
          <div class="soundTopToggle1">
            <div
              @click="toggleFn(2)"
              class="aiBorderSet"
              :class="mark?'aiChangeOneTitleTwo':'aiChangeOneTitleOne'"
            >大中型站点方案：</div>
            <div
              @click="toggleFn(2)"
              :class="mark?'aiChangeTwo':'aiChangeOne'"
              class="aiChangeTwo aiBorderSet"
            >根据实际音频接入量，接入多路模拟/数字内话语音，可集成模型管理、增量训练弹性部署。可根据需求定制应用。</div>
            <div v-if="mark" class="aiArrow"></div>
          </div>
        </div>
      </div>
      <div :class="mark?'soundContentImg':'soundContentImgTog'"></div>
    </div>
  </div>
</template>
<style>
.aiArrow {
  width: 340px;
  height: 19px;
  background: url("../../../common/commonImages/ai_35.png") no-repeat;
  background-size: 100%;
  margin-left: 60px;
  margin-top: 30px;
}
.aiBorderSet {
  border-left: 1px solid #cdcdcd;
}
.ai_flex_items {
  display: flex;
}
.soundTopToggle {
  height: 210px;
}
.aiChangeOneTitleTwo {
  cursor: pointer;
  font-size: 20px;
  width: 461px;
  text-align: center;
  color: #ff714e;
}
.aiChangeOneTitleOne {
  cursor: pointer;
  font-size: 20px;
  color: #a8a8a8;
  width: 461px;
  text-align: center;
}
.aiChangeOne {
  cursor: pointer;
  font-size: 18px;
  color: #a8a8a8;
  width: 461px;
  height: 80px;
  padding: 0 60px;
}
.aiChangeTwo {
  cursor: pointer;
  font-size: 18px;
  color: #000000;
  width: 461px;
  height: 80px;
  padding: 0 60px;
}
.soundProduct {
  height: 775px;
  width: 1186px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
}
.soundProductTitle {
  font-size: 40px;
  margin-bottom: 53px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 30px;
  letter-spacing: 0px;
  color: #ff714e;
}
.soundIntroduce {
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
}
.soundTopToggle {
  display: flex;
}
.soundContentImg {
  width: 1186px;
  height: 447px;
  background: url("../../../common/commonImages/ai_23.png") no-repeat;
  background-size: 100%;
}
.soundContentImgTog {
  width: 1186px;
  height: 447px;
  background: url("../../../common/commonImages/ai_24.png") no-repeat;
  background-size: 100%;
}
</style>
<script>
export default {
  name: "HomeSlide1",
  data() {
    return {
      mark: true
    };
  },
  created: function() {},
  mounted: function() {},
  methods: {
    toggleFn(e) {
      debugger;
      console.log(3333);
      e == 1 ? (this.mark = false) : (this.mark = true);
      //   this.mark = !this.mark;
    }
  }
};
</script>
